module.exports = __webpack_public_path__ + "img/home_setting.555f1f0b.png";